<template>
  <div class="modal-overlay">
    <div class="modal-container">
      <div class="modal-body">
        <div class="modal-header">
          <img
            v-if="getPicture(selectedReport.image) !== ''"
            :src="getPicture(selectedReport.image)"
            class="user-profile"
          />
          <div v-else class="blank-image"></div>
          <img class="icon" src="../../assets/profile_verified.png" v-if="selectedUser.verified">
          <img class="icon" src="../../assets/profile_pro.png" v-if="!selectedUser.verfified && selectedUser.pro_member">
          <div class="user-details">
            <h3>{{ selectedUser.first_name.toUpperCase() }} {{ selectedUser.last_name.toUpperCase() }}</h3>
            <p>{{ selectedUser.email }}</p>
          </div>
          <i class="fas fa-times" @click="closeModal()"></i>
        </div>
      </div>
      <div class="modal-content">
        <div v-if="selectedReport.item_type == 'activity'">
          <div class="date">
            <span>REPORTED POST:</span>
            <span>{{ formatDate(selectedReport.created_at) }}</span>
          </div>
          <div class="content">
            <h5>{{ title }}</h5>
            <p>{{ description }}</p>
            <p>{{ tags }}</p>
            <div class="image-holder">
              <div class="image" v-for="(image, index) in images" :key="index">
                <img :src="getPicture(image)" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="selectedReport.item_type == 'group'">
          <div class="date">
            <span>REPORTED GROUP:</span>
            <span>{{ formatDate(selectedReport.created_at) }}</span>
          </div>
          <div class="content">
            <h5>{{ title }}</h5>
            <p>{{ description }}</p>
            <div class="image-holder">
              <div class="image" v-if="image != ''">
                <img :src="getPicture(image)" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="selectedReport.item_type == 'user'">
          <div class="date">
            <span>REPORTED USER:</span>
            <span>{{ formatDate(selectedReport.created_at) }}</span>
          </div>
          <div class="content">
            <h5>{{ title }}</h5>
            <p>{{ description }}</p>
            <p>Insta: {{ instagramHandle }}</p>
            <div class="image-holder">
              <div class="image" v-if="image != ''">
                <img :src="getPicture(image)" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="selectedReport.item_type == 'comment'">
          <div class="date">
            <span>REPORTED COMMENT:</span>
            <span>{{ formatDate(selectedReport.created_at) }}</span>
          </div>
          <div class="content">
            <h5>{{ title }}</h5>
            <p>{{ description }}</p>
          </div>
        </div>
        <div v-if="selectedReport.item_type == 'message'">
          <div class="date">
            <span>REPORTED MESSAGE:</span>
            <span>{{ formatDate(selectedReport.created_at) }}</span>
          </div>
          <div class="content">
            <h5>{{ title }}</h5>
            <p>{{ description }}</p>
            <div class="image-holder">
              <div class="image" v-if="image != ''">
                <img :src="getPicture(image)" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <span>{{ selectedUser.first_name }} {{ selectedUser.last_name }} REPORT ACTION</span>
        <div class="bottom-row">
          <button @click="ignoreReport()" class="delete-btn">
            IGNORE
          </button>
          <button @click="banUser()" class="delete-btn">
            BAN USER
          </button>
          <button @click="deleteContent(selectedReport.item_type)" class="delete-btn">
            DELETE {{selectedReport.item_type.toUpperCase() }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDateTime } from '@/utils'
import { 
  resolveReport,
  loadReportedActivity,
  loadReportedGroup,
  loadReportedUser,
  loadReportedComment,
  loadReportedMessage,
  deleteUser,
} from '@/api/requests';

export default {
  name: "ReportDetailModal",

  // Valid types of reported content:
  // - activity
  // - group
  // - user
  // - comment
  // - message

  data() {
    return {
      title: '',
      description: '',
      tags: '',
      images: '',
      image: '',
      instagramHandle: '',
    }
  },

  mounted() {
    switch (this.selectedReport.item_type) {
      case 'activity':
        this.loadActivityDetails();
        break;
      case 'group':
        this.loadGroupDetails();
        break;
      case 'user':
        this.loadUserDetails();
        break;
      case 'comment':
        this.loadCommentDetails();
        break;
      case 'message':
        this.loadMessageDetails();
        break; 
    }
  },

  methods: {
    loadActivityDetails() {
      loadReportedActivity(this.selectedReport['item_id']).then((response) => {
        const data = response.data;

        this.title = data.title;
        this.description = data.description;
        this.tags = data.tags;
        this.images = data.images;

        if (this.tags) {
          let jsonTags = JSON.parse(this.tags);
          this.tags = jsonTags.map(tag => '#' + tag.value).join(' ');
        }
      });
    },

    loadGroupDetails() {
      loadReportedGroup(this.selectedReport['item_id']).then((response) => {
        const data = response.data;

        this.title = data.name;
        this.description = data.description;
        this.image = data.image;
      });
    },

    loadUserDetails() {
      loadReportedUser(this.selectedReport['item_id']).then((response) => {
        const data = response.data;

        this.title = `${data.first_name} ${data.last_name}`;
        this.description = data.bio;
        this.instagramHandle = data.instagram_handle;
        this.image = data.image;
      });
    },

    loadCommentDetails() {
      loadReportedComment(this.selectedReport['item_id']).then((response) => {
        const data = response.data;

        this.title = data.title;
        this.description = data.message;
      });
    },

    loadMessageDetails() {
      loadReportedMessage(this.selectedReport['item_id']).then((response) => {
        const data = response.data;

        this.title = data.title;
        this.description = data.message;
        this.image = data.image;
      });
    },
    
    closeModal() {
      this.$store.dispatch('reports/reportDetailsClosed');
    },

    getPicture(image) {
      if (image !== "" && image !== null) {
        if (image.indexOf('blob:') > -1) {
          return image;
        }

        let url = window.location.origin;
        if (url === "http://localhost:8080") {
          url = "http://localhost:3000";
        }
        return url + image;
      }
      return "";
    },

    formatDate(date) {
      return formatDateTime(date);
    },

    banUser() {
      this.$confirm(
        "Are you sure you want to ban " + this.selectedUser.first_name + " " + this.selectedUser.last_name + "? They will not be able to login until unbanned!", 
        "BAN USER").then(() => {
          let payload = {
            'type': 'ban'
          };
          resolveReport(this.selectedReport.id, payload).then(() => {
            this.$store.dispatch('reloadTable');
            this.$store.dispatch('reports/reportDetailsClosed');
            this.$toasted.global.app_success({
              message: "User has been banned."
            });
          });
        }).catch(() => {
          this.$toasted.global.app_error({
            message: "Failed to ban user."
          });
        });
    },

    deleteContent(type) {
      this.$confirm(
        `Are you sure you want to delete this ${type}? Don't forget to manually send them an email!`,
        `DELETE ${type.toUpperCase()}`).then(() => {
          if (type == 'user') {
            deleteUser(this.selectedUser.id).then(() => {
              this.$store.dispatch('reloadTable');
              this.$store.dispatch('reports/reportDetailsClosed');
              this.$toasted.global.app_success({
                message: "User has been deleted."
              });
            });
          }
          let payload = {
            'type': 'delete'
          };
          resolveReport(this.selectedReport.id, payload).then(() => {
            this.$store.dispatch('reloadTable');
            this.$store.dispatch('reports/reportDetailsClosed');
            this.$toasted.global.app_success({
              message: `${type} has been deleted.`
            });
          });
        }).catch(() => {
          this.$toasted.global.app_error({
            message: `Failed to delete ${type}.`
          });
        });
    },

    ignoreReport() {
      this.$confirm(
        "Are you sure you want to ignore this report?", 
        "IGNORE REPORT").then(() => {
          let payload = {
            'type': 'ignore'
          };
          resolveReport(this.selectedReport.id, payload).then(() => {
            this.$store.dispatch('reloadTable');
            this.$store.dispatch('reports/reportDetailsClosed');
            this.$toasted.global.app_success({
              message: "Report has been ignored."
            });
          });
        }).catch(() => {
          this.$toasted.global.app_error({
            message: "Failed to ignore report user."
          });
        });
    }
  },

  computed: {
    selectedUser() {
      return this.$store.state.reports.selectedReport.reported_user;
    },

    selectedReport() {
      return this.$store.state.reports.selectedReport;
    },

    url() {
      let url = window.location.origin;
      if (url === "http://localhost:8080") {
        url = "http://localhost:3000";
      }
      return url;
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";
@import "@/assets/css/internal";

.modal-overlay {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.50);
  z-index: 100;
  left: 0;

  .modal-container {
    background: $sec0;
    width: 40%;
    margin-left: 30%;
    margin-top: 150px;
    box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.55);

    .modal-body {
      background: $sec0;
      padding: $spacing-base;

      .modal-header {
        display: flex;
        align-items: center;

        .user-details {
          flex: 1;
          margin-left: $spacing-base;
          display: flex;
          flex-direction: column;

          h3 {
            color: #FFF;
            padding: 0;
            margin: 0;
            font-size: $font-size-medium;
            display: inline-block;
          }

          p {
            margin: 0;
            padding: 0;
            font-size: $font-size-small;
            color: $sec5;
            font-weight: bold;
            text-transform: uppercase;
          }
        }

        .blank-image {
          width: 40px;
          height: 40px;
          border-radius: 40px;
          background: $sec7;
        }

        .user-profile {
          display: inline-block;
          border-radius: 40px;
          width: 40px;
          height: 40px;
        }
        .icon {
          margin-left: -14px;
          margin-top: -50px;
        }
        i {
          color: $sec4;
          cursor: pointer;
        }
      }
    }

    .modal-content {
      background: $sec1;
      padding: $spacing-small $spacing-base;

      .date {
        display: flex;
        
        span {
          flex: 1;
          color: $sec5;
          font-weight: bold;
          font-size: $font-size-small;
        }
        
        span:last-of-type {
          text-align: right;
        }
      }

      h5 {
        color: #FFF;
        font-size: $font-size-base;
        padding: 0;
        margin-bottom: 0;
      }

      p {
        color: #FFF;
        font-size: $font-size-base;
        padding: 0;
        margin-bottom: 0;
      }

      .image-holder {
        width: 100%;
        height: 115px;
        margin-top: $spacing-small;
        display: flex;
        overflow-x: scroll;

        .image {
          width: 100px;
          height: 100px;
          flex-shrink: 0;
          box-sizing: border-box;
          margin-right: $spacing-small;

          img {
            width: 98px;
            height: 98px;
            overflow: hidden;
          }
        }
      }
    }
  }
}

.picture-option {
  margin-left: 0;
}

.modal-footer {
  background: $sec0;
  padding: $spacing-base;
  display: flex;
  flex-direction: column;
  gap: $spacing-small;

  span {
    font-size: $font-size-small;
    color: $sec5;
    font-weight: bold;
    text-transform: uppercase;
    text-align: center;
  }

  .delete-btn {
    background: $sec0;
    color: $sec5;
    border-color: $sec5;
    border: 0;
    border-radius: 0;
    font-weight: bold;
    height: 32px;
    font-size: $font-size-x-small;
    cursor: pointer;
  }

  .bottom-row {
    display: flex;
    button {
      flex: 1;
      border: 1px solid $sec2;
      width: 100%;
    }
    div {
      flex: 1;
      width: 100%;
    }
  }
}

.disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
</style>